import getFirebase from "../api/firebase";

export interface OrderEmailParams {
  userId: string;
  productId: string;
}

/**
 * Calls the Firebase Cloud Function to send order confirmation emails
 * This sends emails to both the customer and the vendor
 */
export const sendOrderEmail = async (params: OrderEmailParams): Promise<void> => {
  const firebase = await getFirebase();

  // Get the Firebase Cloud Functions endpoint URL
  // In production, this would be: https://us-central1-<project-id>.cloudfunctions.net/orderEmail
  // For development/testing, we can use the functions emulator or the deployed endpoint

  // Option 1: Use Firebase Functions SDK (if available in compat mode)
  // const orderEmailFn = firebase.functions().httpsCallable('orderEmail');
  // await orderEmailFn({ userId: params.userId, productId: params.productId });

  // Option 2: Direct HTTP call (more compatible with the existing setup)
  const projectId = (firebase.app().options as { projectId?: string }).projectId;
  const functionUrl = `https://us-central1-${projectId}.cloudfunctions.net/orderEmail`;

  const response = await fetch(functionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      userId: params.userId,
      productId: params.productId,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to send order email: ${errorText}`);
  }
};

/**
 * Helper function that accepts a product object and extracts the necessary fields
 */
export const sendOrderEmailForProduct = async (product: any): Promise<void> => {
  return sendOrderEmail({
    userId: product.userId,
    productId: product.uid,
  });
};
